// REISOR_STAGE22A_DRIVER_TRIAL_ACCESS_SUBSCRIPTION_V1
// Legacy file name kept for imports. No promo/referral codes, no analytics, no bonus mechanics.
import { getDriverReferralPromoCopy } from "./driverReferralPromoCopy";

// REISOR_DRIVER_SHARE_GOOGLE_PLAY_URL_V1
const REISOR_DRIVER_GOOGLE_PLAY_APP_URL = "https://play.google.com/store/apps/details?id=online.cargo_platform.driver";

const STORAGE_KEY = "driver_invite_promo_code";

export function normalizeDriverPromoCode() {
  return "";
}

export function buildDriverPromoCodeFromId() {
  return "";
}

function originSafe() {
  return REISOR_DRIVER_GOOGLE_PLAY_APP_URL;
}

export function driverIdFromToken(token) {
  const m = String(token || "").match(/drv_([a-f0-9]{24})/i);
  return m ? m[1] : "";
}

export function buildDriverReferralSharePayload({ lang } = {}) {
  const link = originSafe();
  const copy = getDriverReferralPromoCopy(lang);
  const text = copy.shareText({ link });
  return { link, text, promoCode: "" };
}

export function saveDriverInvitePromoCode() {
  try { localStorage.removeItem(STORAGE_KEY); } catch {}
  return "";
}

export function getStoredDriverInvitePromoCode() {
  try { localStorage.removeItem(STORAGE_KEY); } catch {}
  return "";
}

export function clearStoredDriverInvitePromoCode() {
  try { localStorage.removeItem(STORAGE_KEY); } catch {}
}

export function consumeDriverInvitePromoFromUrl() {
  try {
    const url = new URL(window.location.href);
    let changed = false;
    for (const k of ["driverPromo", "promo", "ref", "referralPromoCode", "inviteCode"]) {
      if (url.searchParams.has(k)) {
        url.searchParams.delete(k);
        changed = true;
      }
    }
    clearStoredDriverInvitePromoCode();
    if (changed) {
      window.history.replaceState({}, "", url.pathname + (url.search ? url.search : "") + (url.hash || ""));
    }
  } catch {}
  return "";
}

export function hasStoredDriverInvitePromoCode() {
  return false;
}
